module.exports = __webpack_public_path__ + "img/img_user_1.6c8a269c.png";